/** @jsxImportSource react */
import { abbreviatePrice } from '@common/helpers/abbreviatePrice';
import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';
import React from 'react';
import { Line } from 'react-chartjs-2';

import { LineChartDataType } from '../types/charts';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function getOptions({ stepSize }: { stepSize: number }) {
  return {
    responsive: true,
    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        // position: 'top' as const,
        display: false,
      },
      title: {
        display: false,
      },
    },
    categoryPercentage: 0.5,

    scales: {
      x: {
        ticks: {
          display: true,
        },
        grid: {
          display: false,
          drawBorder: false,
        },
      },
      y: {
        border: {
          display: false,
        },
        position: 'right',
        ticks: {
          display: true,
          stepSize: stepSize || 500,
          callback: abbreviatePrice,
        },
        grid: {
          drawBorder: false,
        },
      },
    },
  };
}

const getFormatPricingDataForChart = (data: LineChartDataType) => {
  return {
    labels: data.map(({ year }) => String(year)),
    datasets: [
      {
        label: 'Monthly median cost',
        data: data.map(({ price }) => price),
        borderColor: 'rgba(26, 116, 115, 1)',
        backgroundColor: 'rgba(26, 116, 115, 1)',
        fill: 'start',
      },
    ],
  };
};

export default function PricingLineChart({
  data,
  stepSize,
}: {
  data: LineChartDataType;
  stepSize: number;
}) {
  const chartData = getFormatPricingDataForChart(data);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return <Line options={getOptions({ stepSize })} data={chartData} />;
}
